import { useEffect } from 'react';
export default function useAutoFocus(inputRef, dependencies) {
    useEffect(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [dependencies]);
}
//# sourceMappingURL=useAutoFocus.js.map